export const MBTI_URL_PARAM = 'mbti'
